import request from '@/utils/request'
import { ConstConfig } from '@/utils'

export function getInsureHomePage() {
  return request({
    url: ConstConfig.apiPath + '/GetInsuranceHomePage.json',
    method: 'get'
  })
}

export function getInsureList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetMyInsuranceList.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/insure.js